import { render, staticRenderFns } from "./ctop.vue?vue&type=template&id=ccc2471c&scoped=true&"
import script from "./ctop.vue?vue&type=script&lang=js&"
export * from "./ctop.vue?vue&type=script&lang=js&"
import style0 from "./ctop.vue?vue&type=style&index=0&id=ccc2471c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc2471c",
  null
  
)

export default component.exports